import type { StationStatus } from '@metro/station-status'

export interface StationServiceState {
  readonly tone: 'good' | 'advisory' | 'closure'
  /** i18n key in the `station-page` namespace. */
  readonly labelKey: string
}

/**
 * Live "Service" fact of the Overview section (Figma 8597:44652).
 * Absent status ⇒ Good service — the only state the design specifies;
 * the advisory / closure labels are the minimal set agreed 2026-08-04
 * until the designer draws the disrupted variants.
 */
export function stationServiceState(status: StationStatus | undefined): StationServiceState {
  if (status === undefined) return { tone: 'good', labelKey: 'service_good' }
  if (status.severity === 'closure') return { tone: 'closure', labelKey: 'service_station_closed' }
  return { tone: 'advisory', labelKey: 'service_minor_disruption' }
}
